
import atlas from "@/components/atlas.vue";
// import atlas from '@/components/discussion.vue';
import gallery from "@/components/homePage/gallery.vue";
import discussion from "@/components/homePage/discussion.vue";
import collected from "@/components/homePage/collected.vue";
import userInfoForm from "@/components/homePage/userInfoForm.vue";
import facus from "@/components/homePage/facus.vue";

export default {
  components: { atlas, gallery, discussion, collected, userInfoForm, facus },
  name: "index",
  middleware: "userAuth", //中间件页面登录鉴权
  head() {
    // 优化seo：动态设置title，keywords 和 description
    return {
      title: this.source.user_info.nickname,
      description: this.source.user_info.signature || "This guy didn't write anything",
      script: [{ src: "https://gosspublic.alicdn.com/aliyun-oss-sdk-6.16.0.min.js" }], //cdn方式引入ali-oss
    };
  },
  data() {
    return {
      source: {
        user_info: { user_label: [] },
        worksList: {},
      }, //数据
      pointsDetail: {},
      nav_type: "gallery",
      dialogVisible: false,
      rand_code: "", //随机码
      userInfoForm: "",
      hottestWork: [], //默认展示作品
      isDisabled: false,
      upload_img: [],
      img_list: [],
      ossConfig: {}, //oss配置
      headers: {},
      notwrite: "This person did not write anything",
      dialogUserInfo: false, //用户详情模态框
      profileRewardShowIcon: false, // 只认 profile_reward.show_xcoins_icon === true
    };
  },
  async asyncData({ $global, query, app, error, req, store, redirect }) {
    if (query.type === 'freeLogin') {
      return {};
    }

    const res = await $global.userInfo({ page: "1", order_type: 1, page_num: 20 });
    const upload_img = [];
    const img_list = [];
    const pointsDetail = await app.$pointsCache.ensurePointDetail();
    if (res.code == 200) {
      if (
        res.data.user_info.hasOwnProperty("prize") &&
        res.data.user_info.prize != null
      ) {
        res.data.user_info.prize.split(",").forEach((currentValue, index) => {
          upload_img.push({ url: currentValue });
          img_list.push({ currentValue });
        });
      }
      return {
        source: res.data,
        rand_code: res.data.rand_code,
        hottestWork: res.data.worksList.data.slice(0, 3),
        upload_img: upload_img,
        img_list: img_list,
        pointsDetail,
      };
    }else {
      console.error(res);
      error({ statusCode: 500 });
    }
  },
  created() {
    // console.log(this.$route);
  },
  async mounted() {
    if (this.$route.query.type === 'freeLogin') {
      await this.handleFreeLogin();
      const { type, ...restQuery } = this.$route.query;
      this.$router.replace({ path: this.$route.path, query: restQuery });
    }
    this.handUserInfoRecord();
    await this.refreshPointsDetail();
    // this.getUserInfoHot()
    // this.$refs.formVisible.$on('studentEvent',this.getSchoolName)
  },
  computed: {
    currentPointsDetail() {
      return Object.keys(this.$store.state.pointDetail || {}).length
        ? this.$store.state.pointDetail
        : this.pointsDetail || {};
    },
    formattedIntegralScore() {
      return this.formatIntegralNumber(this.currentPointsDetail?.points);
    },
    formattedExpiringIntegralScore() {
      return this.formatIntegralNumber(this.currentPointsDetail?.expiringSoonPoints);
    },
    // this.getUserInfoHot()
    // this.$refs.formVisible.$on('studentEvent',this.getSchoolName)
  },
  computed: {
    formattedIntegralScore() {
      return this.formatIntegralNumber(this.pointsDetail?.points);
    },
    formattedExpiringIntegralScore() {
      return this.formatIntegralNumber(this.pointsDetail?.expiringSoonPoints);
    },
  },
  methods: {
    async handleFreeLogin() {
      try {
        const loginRes = await this.$global.terminusLogin();
        if (loginRes.code != 1) {
          this.$router.push("/");
          return;
        }
        this.$store.commit("SETTOKEN", loginRes.data);
        const userRes = await this.$global.xfansLogin(loginRes.data);
        this.$cookies.set("SSOTOKEN", loginRes.data.token, { maxAge: 60 * 60 * 24 * 7 });
        this.$cookies.set("lastVerifiedTime", new Date().getTime());
        if (userRes && userRes.code == 1) {
          this.$store.commit("USER_INFO", userRes.data);
          this.$store.commit("ISLOGIN", true);
          await this.getUserInfo();
        } else {
          this.$router.push("/");
        }
      } catch (err) {
        console.error("Free login error:", err);
        this.$router.push("/");
      }
    },
    formatIntegralNumber(value) {
      const number = Number(value);
      return Number.isFinite(number) ? number.toLocaleString("en-US") : value || 0;
    },
    async refreshPointsDetail() {
      if (!this.$store.state.isLogin || !this.$pointsCache) {
        return;
      }

      this.pointsDetail = await this.$pointsCache.ensurePointDetail();
    },
    // 个人信息,钱包记录
    async handUserInfoRecord() {
      let res = await this.$global.userinfoRecord();
      if (res.code == 200) {
        res.data.user_score_config.forEach((item) => {
          item.bgColor = "";
        });
        res.data.hobby_list.forEach((item) => {
          item.bgColor = "";
        });
        this.userInfoForm = res.data;
        this.isDisabled = true;
        this.applyProfileRewardIcon(res.data.profile_reward);
      }
    },
    // 个人中心
    async getUserInfo() {
      let res = await this.$global.userInfo({ page: "1", order_type: 1, page_num: 20 });
      res.code = "200"
        ? ((this.source = res.data),
          (this.rand_code = res.data.rand_code),
          (this.hottestWork = res.data.worksList.data.slice(0, 3)))
        : [];
      if (
        res.data.user_info.hasOwnProperty("prize") &&
        res.data.user_info.prize != null
      ) {
        this.source.user_info.prize.split(",").forEach((currentValue, index) => {
          this.source.user_info.prize === ""
            ? ""
            : this.upload_img.push({ url: currentValue });
          this.source.user_info.prize === "" ? "" : this.img_list.push({ currentValue });
        });
      }
    },
    getDialogVisible(val) {
      this.dialogVisible = val;
    },
    /** 入口金币只认 show_xcoins_icon === true */
    applyProfileRewardIcon(reward) {
      this.profileRewardShowIcon = !!(reward && reward.show_xcoins_icon === true);
    },
    handleProfileRewardUpdated(reward) {
      this.applyProfileRewardIcon(reward);
    },
    handleProfileRewardClaimed() {
      this.profileRewardShowIcon = false;
    },
    addUplodaImg() {
      this.$refs.selectFiles.$el.children[0].children[1].click();
    },

    // 图片限制
    beforeAvatarUpload(file) {
      let index = file.name.lastIndexOf(".");
      let extn = file.name.substr(index + 1);
      let isFormat =
        ["png", "jpg", "jpeg", "gif", "bmp", "HEIC", "webp"].indexOf(
          extn.toLowerCase()
        ) != -1;
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isFormat) {
        this.$message.error(
          "Upload pictures can only be in PNG,JPG,JPEG,GIF,GMP,HEIC,WEBP format!"
        );
        return false;
      }
      if (!isLt5M) {
        this.$message.error("The uploaded image size cannot exceed 5MB!");
        return false;
      }
      if (isFormat && isLt5M) {
        this.uploading = true;
        this.aliOssUpload(file);
      }
    },
    async aliOssConfig() {
      //获取oss配置
      let res = await this.$global.multiplefile_token();
      res.code == 200 ? (this.ossConfig = res.data) : {};
    },
    async aliOssUpload(file) {
      try {
        // 获取OSS配置
        await this.aliOssConfig();
        // 使用 file.raw 获取原始文件
        const resultOss = await this.$ossUpload(file.raw, this.ossConfig, {

        });

        //防止重复命名
        const result = await this.$global.ossUrlFind({
          oss_url: `https://xfanstemp.oss-us-west-1.aliyuncs.com${resultOss.name}`,
        });

        let user = {
          background_img: result.data.toString(),
          rand_code: this.rand_code,
        };

        let resultEdit = await this.$global.userInfoUploadEdit(user);
        if (resultEdit.code == "200") {
          this.getUserInfo();
        }

      } catch (err) {
        console.error("Upload failed:", err);
        this.uploadloading = false;
        this.$message.error("Upload failed");
      }
    },
    // 图片失败
    imgOnError(e) {
      e.srcElement.src = require("@/assets/image/global/bg-default.webp");
    },
    fansHanle(val) {
      this.$refs.child.dialog(val);
    },
    async signFind() {
      //签到查询
      if (this.$store.state.isLogin) {
        let res = await this.$global.signFind();
        res.code == 200 && res.msg == false
          ? (this.isCheckIn = false)
          : (this.isCheckIn = true);
      }
    },
    async userSignIn() {
      //用户签到
      let res = await this.$global.sign();
      res.code == 200
        ? (this.$message(this.$t('page.SIGN_IN_SUCCESSFULLY')), (this.source.user_info.is_sign = 1))
        : this.$message.error(this.$t('page.SIGN_IN_FAILED'));
    },
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.handUserInfoRecord();
      }
    },
    nav_type(val) {
      if (val == "gallery") {
        this.source.worksList = [];
        this.getUserInfo();
      }
    },
  },
};
